<div
  class="show-more"
  [class.expanded]="!canShowFullText()"
  [isDisabledRipple]="!canShowButton()"
  cheeleeRipple
  (click)="toggle()"
  (transitionend)="onHeightTransitionEnd()"
>
  <p
    #textContent
    class="show-more__text text-1"
    [class.full]="isFullText()"
    [innerHTML]="text | mentionLink"
    cheeleeMentionLink
  ></p>
  <button
    class="show-more__btn bold uppercase"
    *ngIf="canShowButton()"
    [class.user-mode]="mode === 'user'"
  >
    {{ (canShowFullText() ? 'common:more' : 'common:hide') | i18nextEager }}
  </button>
</div>
